import configExtension from './config';

export default [
  configExtension
];
